import React, { createContext, useContext, useState } from 'react';

const ListPropertyContext = createContext(null);

export const ListPropertyProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    // Personal Info fields
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    country: 'AE',
    propertyType: null,
    propertyTitle: '',
    description: '',
    assets: [], // Array of { file: File, preview: string }
    // Address fields
    city: '',
    street: '',
    building: '',
    zipCode: '',
    // Features fields
    floors: null,
    parkingSpaces: null,
    bedrooms: null,
    bathrooms: null,
    furnishingStatus: '',
    balconies: null,
    condition: '',
  });

  const updateFormData = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const addAsset = (file, preview) => {
    setFormData((prev) => ({
      ...prev,
      assets: [...prev.assets, { file, preview }],
    }));
  };

  const removeAsset = (index) => {
    setFormData((prev) => ({
      ...prev,
      assets: prev.assets.filter((_, i) => i !== index),
    }));
  };

  return (
    <ListPropertyContext.Provider
      value={{
        formData,
        updateFormData,
        addAsset,
        removeAsset,
      }}
    >
      {children}
    </ListPropertyContext.Provider>
  );
};

export const useListPropertyContext = () => {
  const context = useContext(ListPropertyContext);
  if (!context) {
    throw new Error('useListPropertyContext must be used within ListPropertyProvider');
  }
  return context;
};

